<template>
  <div id="navigation">
    <div>
      <div class="nav-button" @click="goto('MasksList')" v-bind:class="{activepage: activepage('MasksList')}">
        Masks
<!-- <font-awesome-icon :icon="['fa', 'head-side-mask']" />Masks</div> -->
      </div>
      <div class="nav-button" @click="goto('reservationlist')" v-if="!user.email" v-bind:class="{activepage: activepage('reservationlist')}">
<!-- <font-awesome-icon :icon="['fa', 'shopping-cart']" /> -->
        My List <span class="count" v-if="reservationSize > 0">{{reservationSize}}</span>
      </div>
      <div class="nav-button" @click="goto('reservationadmin')" v-if="user.email" v-bind:class="{activepage: activepage('reservationadmin')}">
<!-- <font-awesome-icon :icon="['fa', 'shopping-cart']" /> -->
        Reservations
      </div>
      <div class="nav-button" @click="goto('FAQ')" v-bind:class="{activepage: activepage('FAQ')}">
        FAQ
      </div>
    </div>
  </div>
</template>

<script>

import Helper from './mixins/HelperFunctions.js'
export default {
  name: 'Navigation',
  mixins: [Helper],
  props: {},
  mounted() {},
  data: function (){
    return {}
  },
  methods: {
    activepage(link) {
      return link == this.$store.getters.getCurrentRoute;
    }
  },
  computed: {
    reservationSize () {
      let masks = this.$store.getters.getReservationList.masks || []
      return masks.length
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.count {
  background-color: #e9c46a;
  border: none;
  color: #264653;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  border-radius: 16px;
}
#navigation {
  background: black;
  position: fixed;
  margin: auto;
  .nav-button {
    display: inline-block;
    color: white;
    margin: 10px auto;
    font-weight: bold;
    padding: 5px 25px;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
    &.activepage {
      border-bottom: 2px solid #e9c46a;
    }
  }
  bottom: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  .link {
    color: white;
  }
}
</style>
